const accessToken = localStorage.getItem(process.env.VUE_APP_ACCESS_TOKEN_KEY);
const refreshToken = localStorage.getItem(
  process.env.VUE_APP_REFRESH_TOKEN_KEY
);
const loggedInUser = JSON.parse(
  localStorage.getItem(process.env.VUE_APP_USER_DATA_KEY)
);

const state = {
  accessToken,
  refreshToken,
  loggedInUser,
};

const getters = {
  isLoggedIn: (state) => !!state.accessToken,
  getAccessToken: (state) => state.accessToken,
  getRefreshToken: (state) => state.refreshToken,
  getLoggedInUser: (state) => state.loggedInUser,
};

const actions = {
  setAccessToken({ commit }, accessToken) {
    commit("SET_ACCESS_TOKEN", accessToken);
  },
  setRefreshToken({ commit }, refreshToken) {
    commit("SET_REFRESH_TOKEN", refreshToken);
  },
  updateTokens({ commit }, { refreshToken, accessToken }) {
    commit("SET_ACCESS_TOKEN", accessToken);
    commit("SET_REFRESH_TOKEN", refreshToken);
  },
  logOut({ commit }) {
    commit("LOG_OUT");
  },
  setLoggedInUser({ commit }, loggedInUser) {
    commit("SET_LOGGED_IN_USER", loggedInUser);
  },
};

const mutations = {
  SET_ACCESS_TOKEN(state, token) {
    state.accessToken = token;
    localStorage.setItem(process.env.VUE_APP_ACCESS_TOKEN_KEY, token);
  },
  SET_REFRESH_TOKEN(state, token) {
    state.refreshToken = token;
    localStorage.setItem(process.env.VUE_APP_REFRESH_TOKEN_KEY, token);
  },
  LOG_OUT(state) {
    state.accessToken = null;
    state.refreshToken = null;
    state.loggedInUser = null;
    localStorage.clear();
  },
  SET_LOGGED_IN_USER(state, loggedInUser) {
    state.loggedInUser = loggedInUser;
    localStorage.setItem(
      process.env.VUE_APP_USER_DATA_KEY,
      JSON.stringify(loggedInUser)
    );
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
